<template lang="pug">
modal#show-signature-pdf-a-when-already-signed-documents-failure-modal(
  :disable-process-button='true'
  :show-cancel-button='false'
  :title='$t("modal.ShowSignaturePdfASignedDocumentsFailureModal.title")'
  ref='modal'
)
  .text {{ $t('modal.ShowSignaturePdfASignedDocumentsFailureModal.message') }}
  .text-center.my-4
    img.img-fluid(src='/img/ilustrations/signature-failure.svg')
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  name: 'ShowSignaturePdfAWhenAlreadySignedDocumentsFailureModal',
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      this.$refs.modal.close();
    },
  },
};
</script>
